(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("learningItemAddSpecificInfo", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: {
                wizard: "="
            },
            templateUrl: "app/learningItems/add/steps/learningItemAddSpecificInfo.html",
            controller: ["$state", LearningItemAddSpecificInfoCtrl],
            controllerAs: "vm"
        };
        function LearningItemAddSpecificInfoCtrl($state) {
            var vm = this;
            vm.$onInit = function () {
                if (vm.wizard.formData.type.stateName !== undefined) {
                    $state.go("main.learningItems.add.step3." + vm.wizard.formData.type.stateName);
                }
            };
        }
    });
}());
